import { adminRoutes } from 'modules/admin/routes/constants';

export const adminNotificationsRoutes = {
  root: `${adminRoutes.root}/notifications`,
};